import React from 'react';
import { Line } from '@react-three/drei';

import { Line2D } from '@paragon/geometry-library';

import { EntitySnapTarget } from '../../library/layout-snapping/EntitySnapTarget';
import { clipLineAroundPoint } from '../util/infiniteLines';
import { useViewCenter } from '../viewCenter';

export function HoveredEntitySnapVisual(props: { snap: EntitySnapTarget; color: string }) {
  const definition = props.snap.definition;
  const infinite = definition instanceof Line2D;

  const viewCenter = useViewCenter(infinite);

  const segment = infinite ? clipLineAroundPoint(definition, viewCenter) : definition;

  const pointArrays = [segment.basePoint.to3D().toArray(), segment.endPoint.to3D().toArray()] as const;

  return <Line lineWidth={2} depthTest={false} color={props.color} points={pointArrays} />;
}
